import React,{Fragment} from "react"

import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Nav from 'react-bootstrap/Nav';
import { Footer } from "./Footer";
import { FooterPrice } from "./FooterPrice";
import  NavbarPrice  from "./NavbarPrice";

export const Carier = () => {
  return (
    
   <>
     <NavbarPrice/> 
    <div className="container" >
      
      <div className="row g-3 ">
        <div className="tex ">
          
          
         
        </div>
        <div className="col-12 col-md-6 col-lg-4">
        
        {[
        'Primary',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>Marketing Intern</Card.Header>
          <Card.Body>
            <Card.Title> Spiccato Games</Card.Title>
            <Card.Text>
              
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}

      {[
        'Success',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>Data Analyst</Card.Header>
          <Card.Body>
            <Card.Title>Spiccato Games </Card.Title>
            <Card.Text>
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}

      {[
        'Success',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>3D Artist</Card.Header>
          <Card.Body>
            <Card.Title>Spiccato Games  </Card.Title>
            <Card.Text>
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}
          
        </div>
        <div className="col-12 col-md-6 col-lg-4">
         
      {[
        'Success',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>Game Developer</Card.Header>
          <Card.Body>
            <Card.Title>Spiccato Games </Card.Title>
            <Card.Text>
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}

      {[
        'Primary',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>Backend Engineer</Card.Header>
          <Card.Body>
            <Card.Title> Spiccato Games </Card.Title>
            <Card.Text>
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}

      {[
        'Danger',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>Customer Support Specialist</Card.Header>
          <Card.Body>
            <Card.Title>Spiccato Games </Card.Title>
            <Card.Text>
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}



        </div>
        <div className="col-12 col-md-6 col-lg-4">
          
      {[
        'Primary',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>3D Art Intern</Card.Header>
          <Card.Body>
            <Card.Title>Spiccato Games </Card.Title>
            <Card.Text>
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}

      {[
        'Info',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>Graphic Designer/Marketing Specialist</Card.Header>
          <Card.Body>
            <Card.Title> Spiccato Games </Card.Title>
            <Card.Text>
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}

      {[
        'Info',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>Illustrator/AnimatorDesigner</Card.Header>
          <Card.Body>
            <Card.Title>Spiccato Games </Card.Title>
            <Card.Text>
            Spiccato Games
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}
        </div>
      </div>
    </div>
    {/* <FooterPrice/> */}
    </>
    /*
    <div className=''>
      <NavBar/>

     
      {[
        'Primary',
        ].map((variant) => (
        <Card
          bg={variant.toLowerCase()}
          key={variant}
          text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
          style={{ width: '18rem' }}
          className="card1"
        >
          <Card.Header>Header</Card.Header>
          <Card.Body>
            <Card.Title>{variant} Card Title </Card.Title>
            <Card.Text>
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </Card.Text>
          </Card.Body>
        </Card>
        

        //

        ))}
       
    </>
    
  */  

)}

